export const profile = {
    breadcrumb: {
        viewProfile: 'Profile',
    },
    title: 'Personal information',
    form: {
        labels: {
            email: 'Email',
            role: 'Role',
            firstName: 'First name',
            lastName: 'Last name',
            ldapUsername: 'LDAP username',
            phoneNumber: 'Phone number',
            jobTitle: 'Job title',
            company: 'Company',
            address: 'Address',
            city: 'City',
            countryId: 'Country',
            language: 'Language',
            timezone: 'Timezone',
            dateFormat: 'Date format',
            tfa: 'Two-factor authentication',
        },
        buttons: {
            save: 'Save',
            changePassword: 'Change password',
        },
    },
    update: {
        success: 'Update personal information successfully',
    },
};
